import React from "react";
import ReactDOM from "react-dom";
import Dict from 'dict-lib';
import {PropertyType} from './tabs/PropertyType';
import {
    Tabs,
    Tab
} from 'react-bootstrap';
import './Properties.css';
import {PropertyTypeItems} from "../AdministrationHelper";

export class Properties extends React.Component {
    constructor(props) {
        super(props);

        this.optionGroups = [
            {flag: 'base', name: 'BASE', isModule: false},
            {flag: 'various', name: 'VARIOUS', isModule: false},
            {flag: 'modules', name: 'MODULES', isModule: false},
        ];

        PropertyTypeItems.RootModules.forEach((module) => {

            var flag = module.code;
            var name = module.code;
            var isModule = true;
            var additionalModules = [{flag, name, isModule}];
            if (typeof module.referenceModule === 'undefined')
                additionalModules.push({
                    flag: flag + '-FRONTEND',
                    name: Dict.t(name) + ' - frontend',
                    isFrontend: true,
                    isModule
                });

            this.optionGroups = this.optionGroups.concat(additionalModules);
        });

        this.state = ({
            key: typeof this.props.defaultActiveTab === 'undefined' ? 0 : this.optionGroups.findIndex((opt) => {
                return opt.flag === this.props.defaultActiveTab
            }),
        });

        this._handleSelect = this._handleSelect.bind(this);
    }

    _handleSelect(key) {
        this.setState({key});
    }


    render() {
        const tabs = this.optionGroups.map((item, index) =>
            <Tab key={'key-tab-properties-' + index} eventKey={index} title={item.isFrontend ? item.name : Dict.t(item.name)}>
                <PropertyType key={'key-props-' + item.flag} tab={item.flag} isModule={item.isModule}/>
            </Tab>);

        return (
            <Tabs key={'key-tab-properties'} activeKey={this.state.key} onSelect={this._handleSelect}
                  id="properties-tab">
                {tabs}
            </Tabs>
        );

    }
}

